/**************************************************
 * Nombre:       Tarjeta_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {East} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Servicios = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                color: theme.palette.primary.main,
                height: 350,
                my: 2,
                mx: 4,


            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',mt: 1}}>
                <img src={item.icono} width={!masSM ? 40 :50} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{
                    textAlign: 'center',
                    fontWeight: 800,
                    lineHeight: 1.4,
                    fontSize: !masSM ? 14 : 16
                }}>{item?.titulo.toUpperCase()}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 0}}
            >

                {item && item.items && item.items.map((it, index) => {

                    return (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontWeight: 400, textAlign: 'center', fontSize: !masSM ? 14 : 16}}>{it}</Typography>
                        </Grid>
                    )

                })}

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <IconButton>
                    <East sx={{fill: theme.palette.secondary.main}}/>
                </IconButton>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Servicios    